import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

/**
 * Get the custom topic name (if the LD feature toggle is enabled)
 *
 * @returns {string} name
 */
const useCustomTopicName = () => {
  const { currentUser, currentNetwork } = useDefaultAppContexts();
  const defaultName = s__('Topics|Group');

  if (!currentUser) {
    return currentNetwork?.features?.topics?.config?.custom_topic_name;
  }

  const topicName =
    currentNetwork?.network_configuration?.topics_v2?.custom_topic_name;

  return topicName || defaultName;
};

export default useCustomTopicName;
